export const HiringPlanEnglish = {
  title: 'Hiring plan',
  subTitle: 'Create requisitions to request the creation of new jobs and hiring of new employees.',
  enableHiringPlan: 'Enable Hiring plan',
  addApprovalFlow: 'Add approval flow',
  editApprovalFlow: 'Edit approval flow',
  addEditApprovalFlowSubTitle: 'This approval process will be applied to each requisition submitted by the team members.',
  addApprovalStep: 'Add approval step',
  defaultApprovalFlow: 'Default approval flow'
}

export const HiringPlanArabic = {
  title: 'خطة التوظيف',
  subTitle: 'إنشاء فتحات لطلب خلق فرص عمل جديدة وتعيين موظفين جدد.',
  enableHiringPlan: 'تمكين خطة التوظيف',
  addApprovalFlow: 'Add approval flow', // TODO transalte
  editApprovalFlow: 'Edit approval flow',
  addEditApprovalFlowSubTitle: 'سيتم تطبيق عملية الموافقة هذه على كل افتتاح يقدمه أعضاء الفريق.',
  addApprovalStep: 'إضافة خطوة الموافقة',
  defaultApprovalFlow: 'تدفق الموافقة الافتراضية'
}
